<script>
import agentHeader from "../common/agentHeader.vue";
import ListingsSearchBar from "./listingsSearchBar.vue";
import Report from "./report"
import { mapActions } from 'vuex'
import moment from 'moment'
import html2canvas from 'html2canvas';
import jsPDF from "jspdf"

export default {
  data() {
    return {
      page: 1,
      size: 25,
      total: '',
      pageLiveReservations: 1,
      sizeLiveReservations: 25,
      totalLiveReservations: '',
      activeNames: ['1'],
      providedBackgroundColor: '',
      providedImageSrc: '',
      liveListings: [

      ],
      liveReservations: [

      ],
      soldProperties: [

      ],
      pastListings: [

      ],
      pdfdialogVisible: false,
      fullscreenLoading: '',
      startDate: '',
      endDate: "",
      pdfListingId: "",
      pdfTimeShow: '',
      propertyPdfInfo: {
        houseInfo: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
    };
  },
  props: {
    adminRole: String
  },
  methods: {
    ...mapActions(['getHouseLists', 'deleteHouse', 'getPropertyPdfInfo', 'getLiveReservationsList']),
    goBack() {
      this.$router.go(-1)
    },
    handleChange(val) {
      console.log(val);
    },
    handleSizeChange(val) {
      this.size = val
      this.gethome()
    },
    handleCurrentChange(val) {
      this.page = val
      this.gethome()
    },
    handleSizeChangeLiveReservations(val) {
      this.sizeLiveReservations = val
      this.getLiveReservations()
    },
    handleCurrentChangeLiveReservations(val) {
      this.pageLiveReservations = val
      this.getLiveReservations()
    },
    navigateToAddListing() {
      this.$router.push({ path: '/createlisting' })
    },

    handleClickViewAgent(val) {
      console.log(val)
      this.$router.push({ path: '/viewListing', query: { pid: val } })
    },

    handleClickEditAgent(val) {
      this.$router.push({ path: '/createlisting', query: { pid: val } })
    },

    handleClickDeleteAgent(val) {
      console.log(val)

      this.$confirm('Do you really want to delete?', '', {
        confirmButtonText: 'Confirm', confirmButtonClass: 'confirm-class'
      })
        .then(_ => {
          this.delhouse(val)
        })
        .catch(_ => { });
    },
    viewProperty(val) {

      // if(val.uconnect){
      //   // this.$router.push({path:'/uconnect/view',query:{pid:val.propertyId}})
      //   const routeData = this.$router.resolve({path:'/uconnect/view',query:{pid:val.propertyId}});
      //   window.open(routeData.href, '_blank');
      // }else{
      //   let webBaseUrl = process.env.VUE_APP_UNIFI;
      //   window.open(
      //     `${webBaseUrl}#/property-details/view?pid=${val.propertyId}`
      //   );
      // }
      const routeData = this.$router.resolve({path:'/uconnect/view',query:{pid:val.propertyId}});
      window.open(routeData.href, '_blank');

    },
    gethome(searchValues) { // 获取列表

      let pat = {}
      if (searchValues) {

        pat.page = this.page
        pat.size = this.size
        pat.lineType = 'online'
        pat.proertyType = searchValues.propertyType
        pat.uconnectType = searchValues.uconnectType
        pat.search = searchValues.search
        pat.agency = searchValues.agency
        pat.suburb = searchValues.suburb

      }
      else {
        pat.page = this.page
        pat.size = this.size
        pat.lineType = 'online'
        pat.proertyType = this.status == 'All' ? 'all' : this.status,
          pat.search = this.search

      }
      console.log(pat)
      this.getHouseLists({ pat: pat, callback: this.callback })
    },
    getLiveReservations(searchValues) {
      let pat = {}
      if (searchValues) {
        pat.page = this.pageLiveReservations
        pat.size = this.sizeLiveReservations
        pat.lineType = 'reserved'
        pat.proertyType = searchValues.propertyType
        pat.uconnectType = searchValues.uconnectType
        pat.search = searchValues.search
        pat.agency = searchValues.agency
        pat.suburb = searchValues.suburb
      }
      else {
        pat.page = this.pageLiveReservations
        pat.size = this.sizeLiveReservations
        pat.lineType = 'reserved'
        pat.proertyType = this.status == 'All' ? 'all' : this.status
        pat.search = this.search
      }
      console.log(pat)
      this.getLiveReservationsList({ pat: pat, callback: this.callback })
    },
    formatUnixTime(unixTime) {
      const date = new Date(unixTime * 1000); // Convert to milliseconds
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

      return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    },
    delhouse(val) { // 删除
      this.deleteHouse({ pat: { propertyId: val }, callback: this.callback })
    },
    callback(resp, status) {
      switch (status) {
        case 'getHouseLists':
          if (resp.code == 0) {
            this.liveListings = resp.data.list
            this.total = resp.data.totalRecord
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'getLiveReservationsListCallback':
          if (resp.code == 0) {
            this.liveReservations = resp.data.list
            this.totalLiveReservations = resp.data.totalRecord
            this.sizeLiveReservations = resp.data.pageSize
            this.pageLiveReservations = resp.data.pageNo
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'deleteHouse':
          if (resp.code == 0) {
            this.delDio = false
            this.gethome()
            Utils.alert('', 'Listing has been deleted!', 'success')
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
      }
    },
    formatDate(date) {
      let formateddate = Date.parse(date)
      let formateddate2 = new Date(Date.parse(date))
      formateddate2.formatDate("dd/MM/yyyy")
      return formateddate;
    },
    moment: function (val) {
      let d = moment(val)
      return d;
    },
    triggerSearch(searchValues) {
      this.gethome(searchValues)
    },
    exportPdf(id) {
      this.pdfListingId = id
      this.startDate = ''
      this.endDate = ''
      this.pdfdialogVisible = true
    },
    isMoreThanOneYear(startTimestamp, endTimestamp) {
      const startDate = new Date(startTimestamp);
      const endDate = new Date(endTimestamp);

      // 计算开始日期加一年的时间戳
      const oneYearLater = new Date(startDate);
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

      // 判断结束日期是否在加一年后
      return endDate > oneYearLater;
    },
    downloadPdf() {
      if (!this.startDate || !this.endDate) {
        Utils.alert('', 'Please select start and end times', 'error')
        return
      }
      const start = Date.parse(new Date(`${this.startDate} 00:00:00`))
      const end = Date.parse(new Date(`${this.endDate} 23:59:59`))
      if (start > end) {
        Utils.alert('', 'The start date cannot be greater than the end date', 'error')
        return
      }

      if (this.isMoreThanOneYear(new Date(this.startDate).getTime(), new Date(this.endDate).getTime())) {
        Utils.alert('', 'Only export data for 1 year at most', 'error')
        return
      }
      this.pdfTimeShow = `${moment(new Date(start)).format('MMMM D, yyyy')} - ${moment(new Date(end)).format('MMMM D, yyyy')}`
      this.fullscreenLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const pat = {
        propertyId: this.pdfListingId,
        startTime: start / 1000,
        endTime: end / 1000
      }
      this.getPropertyPdfInfo({
        pat: pat, callback: res => {
          if (res.code === 0) {
            const data = res.data
            let agentList = []
            const agentInfo = {
              agentId: data.housePropertyInfoPojo.agentId,
              agentFirstName1: data.housePropertyInfoPojo.agentFirstName1,
              agentImageBio1: data.housePropertyInfoPojo.agentImageBio1,
              agentImageUrl1: data.housePropertyInfoPojo.agentImageUrl1,
              agentLastName1: data.housePropertyInfoPojo.agentLastName1,
              agentMobile1: data.housePropertyInfoPojo.agentMobile1 ? data.housePropertyInfoPojo.agentMobile1 : '-',
            }
            if (data.housePropertyInfoPojo.agentId2) {
              agentList = [agentInfo, {
                agentId2: data.housePropertyInfoPojo.agentId2,
                agentFirstName1: data.housePropertyInfoPojo.agentFirstName2,
                agentImageBio1: data.housePropertyInfoPojo.agentImageBio2,
                agentImageUrl1: data.housePropertyInfoPojo.agentImageUrl2,
                agentLastName1: data.housePropertyInfoPojo.agentLastName2,
                agentMobile1: data.housePropertyInfoPojo.agentMobile2 ? data.housePropertyInfoPojo.agentMobile2 : '-',
              }]
            } else {
              agentList = [agentInfo]
            }
            data.housePropertyInfoPojo.price = Utils.formatSplit(data.housePropertyInfoPojo.price, true);
            data.housePropertyInfoPojo.maxPrice = data.housePropertyInfoPojo.maxPrice ? Utils.formatSplit(data.housePropertyInfoPojo.maxPrice, true) : '';
            data.housePropertyInfoPojo.rental = Utils.formatSplit(data.housePropertyInfoPojo.rental, true);
            data.housePropertyInfoPojo.maxRental = Utils.formatSplit(data.housePropertyInfoPojo.maxRental, true);
            data.houseInfo = data.housePropertyInfoPojo !== null ? data.housePropertyInfoPojo : ''

            data.propertyImg = data.housePropertyInfoPojo.imageUrl ? data.housePropertyInfoPojo.imageUrl.split(',')[0] : ''
            data.agentList = agentList
            if (data.actionsLogStatics) {
              Object.keys(data.actionsLogStatics).forEach(key => {
                if (typeof data.actionsLogStatics[key] === 'number' && key !== 'timeOnPage') {
                  data.actionsLogStatics[key] = Utils.numberWithCommas(data.actionsLogStatics[key]);
                } else {
                  data.actionsLogStatics[key] = data.actionsLogStatics[key] === 0 ? 0 : parseInt(data.actionsLogStatics[key] / 60) < 1 ? 1 : parseInt(data.actionsLogStatics[key] / 60);
                }
              });
            }
            if (data.viewLogStaticsList && data.viewLogStaticsList.length) {
              let viewLineXData = []
              let viewLineYData = []
              data.viewLogStaticsList.forEach(item => {
                viewLineXData.push(item.rq)
                viewLineYData.push(item.numbers)
              })
              data.viewLineXData = viewLineXData
              data.viewLineYData = viewLineYData
            } else {
              data.viewLineXData = []
              data.viewLineYData = []
            }
            if (data.tabViewsStaticsList && data.tabViewsStaticsList.length) {
              data.tabViewStaticsLength = data.tabViewsStaticsList.length
              let tabBarXData = []
              let tabBarYData = []
              const noValue = Math.max(7 - data.tabViewsStaticsList.length, 0);
              const noList = new Array(noValue).fill('')
              data.tabViewsStaticsList.forEach(item => {
                const num = item.numbers
                if (num == 0) return
                tabBarXData.push(item.tabName)
                tabBarYData.push(num)
              })
              data.tabBarXData = [...tabBarXData]
              data.tabBarYData = [...tabBarYData]
            } else {
              data.tabBarXData = []
              data.tabBarYData = []
            }
            if (data.timeOnTabList && data.timeOnTabList.length) {
              data.timeOnTabLength = data.timeOnTabList.length
              let tabBarXData1 = []
              let tabBarYData1 = []
              const noValue = Math.max(7 - data.timeOnTabList.length, 0);
              const noList = new Array(noValue).fill('')
              data.timeOnTabList.forEach(item => {
                const num = item.numbers === 0 ? 0 : (item.numbers / 60) < 1 ? 1 : (item.numbers / 60).toFixed(0)
                if (num == 0) return
                tabBarXData1.push(item.tabName)
                tabBarYData1.push(num)
              })
              data.tabBarXData1 = [...tabBarXData1]
              data.tabBarYData1 = [...tabBarYData1]
            } else {
              data.tabBarXData1 = []
              data.tabBarYData1 = []
            }
            this.propertyPdfInfo = data
            console.log(data);
            setTimeout(() => {
              this.exp()
            }, 1000)
            // this.fullscreenLoading.close()
            // this.pdfdialogVisible = false
            // this.startDate = ''
            // this.endDate = ''
          } else {
            this.fullscreenLoading.close()
            Utils.alert("", res.message, 'error');
          }
        }
      })
    },
    exp() {
      const element = document.getElementById("report-main");
      if (!element) {
        this.fullscreenLoading.close()
        Utils.alert("", 'Export failed, please try again.', 'error');
        return
      }
      try {
        html2canvas(element, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          scale: 2,
          willreadoften: true
        }).then((canvas) => {
          var pageData = canvas.toDataURL('image/jpeg', 1.0);
          const w = 595.28
          const h = 592.28
          var pdf = new jsPDF('p', 'pt', [w, (h / canvas.width * canvas.height)]);
          pdf.addImage(pageData, 'JPEG', 0, 0, w, (h / canvas.width * canvas.height));
          const addressStr = `${this.propertyPdfInfo.houseInfo.address ? `${this.propertyPdfInfo.houseInfo.address}, ` : ''}${this.propertyPdfInfo.houseInfo.suburb ? ' ' + this.propertyPdfInfo.houseInfo.suburb : ''}${this.propertyPdfInfo.houseInfo.state ? ' ' + this.propertyPdfInfo.houseInfo.state : ''}${this.propertyPdfInfo.houseInfo.postcode ? ' ' + this.propertyPdfInfo.houseInfo.postcode : ''}`

          console.log(addressStr);
          setTimeout(() => {
            pdf.save(`Property Campaign Report - ${addressStr}.pdf`);
            this.fullscreenLoading.close()
            this.pdfdialogVisible = false
            this.startDate = ''
            this.endDate = ''
            this.propertyPdfInfo.houseInfo = ''
          }, 1000)
        });
      } catch (error) {
        this.fullscreenLoading.close()
        Utils.alert("", 'Export failed, please try again.', 'error');
      }
    }
  },
  mounted() {
    // if (this.adminRole=4){ // don't all u-connect role to access listings
    //   this.$router.push('/dashboard')
    // }
    this.gethome()
    this.getLiveReservations()
  },
  components: {
    agentHeader,
    ListingsSearchBar,
    Report
  }
}
</script>

<template>
  <div>
    <!--<agent-header :providedBackgroundColor="providedBackgroundColor" :providedImageSrc="providedImageSrc"/>-->
    <Report v-if="propertyPdfInfo.houseInfo" id="report-main" :pdfTimeShow="pdfTimeShow"
      :propertyPdfInfo="propertyPdfInfo" />
    <div class="faq">
      <el-row>
        <el-col :span="12">
          <div class="title-text">Listing</div>
        </el-col>
        <el-col :span="12">
          <div @click="goBack()" class="back-button" style="text-decoration: underline; cursor: pointer"><i
              class="el-icon-arrow-left"></i>BACK</div>
        </el-col>
      </el-row>
      <el-row style="display: flex; align-items: end; margin-top: 15px">
        <el-col :span="8">
          <el-button class="addNewListingBtn" @click="navigateToAddListing">Create New Listing</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-collapse v-model="activeNames" @change="handleChange" style="margin-top: 24px">
          <el-collapse-item name="1">
            <Listings-Search-Bar @searchTrigger="triggerSearch" :adminRole="this.adminRole" />
            <template slot="title">Live Listings</template>
            <el-table :data="liveListings" style="width: 100%" class="fontFamily">
              <el-table-column min-width="45" prop="propertyId" label="ID" class="fontFamily"></el-table-column>

              <el-table-column prop="companyName" label="Agency" class="fontFamily"></el-table-column>
              <el-table-column prop="address" label="Address" class="fontFamily"></el-table-column>
              <el-table-column prop="suburb" label="Suburb" class="fontFamily"></el-table-column>

              <el-table-column min-width="55" prop="" label="Listing Date" class="fontFamily">
                <template v-slot:default="scope">
                  <span v-if="scope.row.launchDate">{{ moment(scope.row.launchDate).format("DD/MM/YYYY") }}</span>
                </template>
              </el-table-column>


              <el-table-column min-width="55" prop="proertyType" label="Property Type"
                class="fontFamily"></el-table-column>
              <el-table-column min-width="120" label="Actions" class="fontFamily">
                <template slot-scope="scope">
                  <el-button class="edit-link" @click="exportPdf(scope.row.propertyId)" type="text" size="small"
                    icon="el-icon-download">Export</el-button>
                  <span class="divider"> | </span>
                  <el-button class="edit-link" @click="handleClickEditAgent(scope.row.propertyId)" type="text"
                    size="small" icon="el-icon-edit">Edit</el-button>
                  <span class="divider"> | </span>
                  <el-button class="remove-link" @click="handleClickDeleteAgent(scope.row.propertyId)" type="text"
                    size="small" icon="el-icon-delete">Delete</el-button>
                  <span class="divider"> | </span>
                  <el-button class="remove-link" @click="viewProperty(scope.row)" type="text"
                             size="small" icon="el-icon-link">View</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="fen" v-if="total">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-size="25" layout="total, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">Live Reservations</template>
            <el-table :data="liveReservations" style="width: 100%" class="fontFamily">
              <el-table-column prop="propertyId" label="Property ID" class="fontFamily"></el-table-column>
              <el-table-column prop="apt" label="Dwelling #" class="fontFamily"></el-table-column>
              <el-table-column prop="address" label="Address" class="fontFamily"></el-table-column>
              <el-table-column prop="suburb" label="Suburb" class="fontFamily"></el-table-column>
              <el-table-column prop="propertyType" label="Property Type" class="fontFamily"></el-table-column>
              <el-table-column prop="propertyStatus" label="Status" class="fontFamily"></el-table-column>
              <el-table-column label="Date" class="fontFamily">
                <template v-slot="scope">
                  <span>{{ formatUnixTime(scope.row.reserveTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Buyer" class="fontFamily">
                <template v-slot="scope">
                  <span>{{ scope.row.buyerFirstName + ' ' + scope.row.buyerSurName }}</span>
                  <span>{{ scope.row.buyerEmail }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Legal Rep." class="fontFamily">
                <template v-slot="scope">
                  <span>{{ scope.row.legalCompanyName }}</span>
                  <span>{{ scope.row.legalEmail }}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="120" label="Actions" class="fontFamily">
                <template v-slot="scope">
                  <el-button class="remove-link" @click="viewProperty(scope.row)" type="text"
                             size="small" icon="el-icon-link">View</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="fen" v-if="totalLiveReservations">
              <el-pagination @size-change="handleSizeChangeLiveReservations" @current-change="handleCurrentChangeLiveReservations" :current-page="pageLiveReservations"
                             :page-size="sizeLiveReservations" layout="total, prev, pager, next, jumper" :total="totalLiveReservations">
              </el-pagination>
            </div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">Sold Properties</template>
            <el-table :data="soldProperties" stripe style="width: 100%" class="fontFamily">
              <el-table-column prop="id" label="ID" class="fontFamily"></el-table-column>
              <el-table-column prop="address" label="Address" class="fontFamily"></el-table-column>
              <el-table-column prop="soldDate" label="Sold Date" class="fontFamily"></el-table-column>
              <el-table-column prop="propertyType" label="Property Type" class="fontFamily"></el-table-column>
              <el-table-column prop="actions" label="Actions" class="fontFamily"></el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template slot="title">Past Listings</template>
            <el-table :data="pastListings" style="width: 100%" class="fontFamily">
              <el-table-column prop="id" label="ID" class="fontFamily"></el-table-column>
              <el-table-column prop="address" label="Address" class="fontFamily"></el-table-column>
              <el-table-column prop="archiveDate" label="Archive Date" class="fontFamily"></el-table-column>
              <el-table-column prop="propertyType" label="Property Type" class="fontFamily"></el-table-column>
              <el-table-column prop="actions" label="Actions" class="fontFamily"></el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-row>
    </div>

    <el-dialog custom-class="pdfDialog-box" :visible.sync="pdfdialogVisible" width="365px">
      <div slot="title">
        <span class="pdfDialog-title">Export Report</span>
      </div>
      <span class="pdfDialog-tip">Please select the time period you want to export</span>
      <div style="display: flex;justify-content: space-between;align-items:center;">
        <div>
          <p class="pdfDialog-tip timeTip">Start Date</p>
          <el-date-picker :clearable='false' class="pdf-timepicker" :picker-options="pickerOptions"
            format="MMM dd, yyyy" value-format="yyyy/MM/dd" v-model="startDate" type="date" placeholder="Select...">
          </el-date-picker>
        </div>
        <span style="margin-top: 45px;">-</span>
        <div>
          <p class="pdfDialog-tip timeTip">End Date</p>
          <el-date-picker :clearable='false' class="pdf-timepicker" :picker-options="pickerOptions"
            format="MMM dd, yyyy" value-format="yyyy/MM/dd" v-model="endDate" type="date" placeholder="Select...">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="exportListingBtn" @click="downloadPdf">Export</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.faq {
  border-radius: 0px 0px 5px 5px;
  background-color: #ffffff;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 100%;
  padding: 30px 25px 30px 30px;
}


.title-text {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  flex-grow: 1;
  flex-basis: auto;
  margin: auto 0;
  font: 600 24px DINosaur-a, sans-serif;
}

.back-button {
  color: #003333;
  text-align: right;
  font-feature-settings: "clig" off, "liga" off;
  white-space: nowrap;
  font: 600 24px DINosaur-a, sans-serif;
}

.edit-link {
  color: #003333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: 'DINosaur-a';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 125% */
  text-decoration-line: underline;
}

.remove-link {
  color: #003333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: 'DINosaur-a';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 125% */
  text-decoration-line: underline;
}


.addNewListingBtn {
  color: #ffffff;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  align-self: start;
  font: 600 20px DINosaur-a, sans-serif;
}


/*.el-table /deep/ tr:nth-child(even) {
  background: rgba(0, 51, 51, 0.56);
}*/

.addNewListingBtn:hover {
  color: #ffffff;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  align-self: start;
  font: 600 20px DINosaur-a, sans-serif;
}

@media (max-width: 991px) {
  .faq {
    max-width: 100%;
    padding: 0 20px;
  }

  .addNewListingBtn {
    white-space: initial;
  }

  .addNewListingBtn:hover {
    white-space: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/listing/listings.vue